
import styles from './estudantePage.module.css';
import LoginComponent from '../../components/estudante/loginForm.jsx'
import RegisterComponent from '../../components/estudante/registerForm.jsx'
import Header from '../../components/Header/headerForm.jsx'
import Footer from '../../components/Footer/FooterForm.jsx';

import React, { useState,useEffect } from 'react';
import { Helmet } from "react-helmet";



const LoginForm = () => {

  
  const [isLoginModalOpen, setisLoginModalOpen] = useState(false);

  const toggleRegisterModal = () => {
    setisLoginModalOpen(!isLoginModalOpen);
  };

  const [isRegisterModalOpen, setisRegisterModalOpen] = useState(false);

  const toggleLoginModal = () => {
    setisRegisterModalOpen(!isRegisterModalOpen);
  };
  
  return (

    <>
    <Helmet>
      <title>Estudante | Link Estágio</title>
      <meta 
        name="description" 
        content="Cadastre-se gratuitamente e encontre as melhores vagas de estágio para iniciar sua carreira. Conectamos estudantes com empresas de todo o Brasil." 
      />
    </Helmet>
    <Header />
    <div className={styles.largeDiv}></div> {/* Adicione a classe aqui */}
    <div className={styles.fullBackground}>

      <div className={styles.loginRegisterContainer}>
          <LoginComponent 
           isLoginModalOpen={isLoginModalOpen} 
           toggleRegisterModal={toggleRegisterModal} 
           onLoginSuccess={toggleLoginModal}
           />
          <RegisterComponent 
          isRegisterModalOpen={isRegisterModalOpen} 
          toggleLoginModal={toggleLoginModal} 
          onRegisterSuccess={toggleRegisterModal}/>
        </div>
      </div>
    <Footer />
    </>
  );
};

export default LoginForm;
